import { React, useState, useEffect, createContext } from "react";
import { BrowserRouter, Route, Routes, useParams, Navigate, useResolvedPath } from "react-router-dom";
import Layout from "./Components/Layout/Layout";
import AddressBook from "./Pages/Base/AddressBook/AddressBook";
import { Mfa } from "./Components/MFA/Mfa";
import { Login } from "./Components/Authetication/Login";
import { ResetPassword } from "./Components/Authetication/ResetPassword";
import PrivateRoute from "./PrivateRoute";
import { GlobalProvider } from "./Providers/GlobalProvider";
import { ForgetPassword } from "./Components/Authetication/ForgetPassword";
import { PopupProvider } from "./Providers/PopupProvider";
import SecurityPolicies from "./Pages/Base/SecurityPolicies/SecurityPolicies";
import ClientEdit from "./Pages/Base/Stakeholders/ClientEdit/ClientEdit"
import Rds_fields from "./Pages/Base/ControlPanel/RdsFields/RdsFields";
import Factors from "./Pages/Base/ControlPanel/Factors";
import Fields from "./Pages/Base/ControlPanel/Field/Fields";
import DataCollectionConfig from "./Pages/Base/ControlPanel/DataCollectionConfig/DataCollectionConfig";
import CheckLists from "./Pages/Base/ControlPanel/Checklist/CheckLists";
import Prompts from "./Pages/Base/ControlPanel/Prompts/Prompts";
import Users from "./Pages/Base/ControlPanel/Users/Users";
import GatewayPermissions from "./Pages/Base/ControlPanel/GatewayPermissions/GatewayPermissions";
import Outbox from "./Pages/Base/ControlPanel/Outbox/Outbox"
import UsageLog from "./Pages/Base/ControlPanel/UsageLog/UsageLog";
import FieldConfig from "./Pages/Base/ControlPanel/FieldConfig/FieldConfig";
import TableConfig from "./Pages/Base/ControlPanel/TableConfig/TableConfig";
import "primeflex/primeflex.css";
import ToolTip from "./Pages/Base/ControlPanel/Tooltip/ToolTip";
import DataSubmitted from "./Pages/Base/ControlPanel/DataSubmitted/DataSubmitted";
import Setup from "./Pages/Base/ControlPanel/Setup/Setup";
import Permissions from "./Pages/Base/ControlPanel/Permissions/Permissions";
import CompletionTracker from "./Pages/Base/ControlPanel/CompletionTracker/CompletionTracker";
import PortfolioTabs from "./Pages/Base/Portfolio/portfolioTabs";
import { list } from "./Services/branchService";
import { getBranchUser } from "./Services/userService";
import ActivityPlanTemplate from "./Pages/Base/ControlPanel/ActivityPlan/ActivityPlanTemplate";
import Stages from "./Pages/Base/ControlPanel/Stages/Stages";
import UserClassification from "./Pages/Base/ControlPanel/UserClassification/UserClassification";
import JobTitles from "./Pages/Base/ControlPanel/JobTitles/JobTitles";
import Programmes from "./Pages/Base/Programmes/Programmes";
import ProgrammeTabs from "./Pages/Base/Programmes/ProgrammeTabs";
import Dashboard from "./Pages/Base/Dashboard/Dashboard";
import ChangePassword from "./Pages/Base/MyAccount/ChangePassword/ChangePasword";
import MyAccount from "./Pages/Base/MyAccount/MyAccount";
import Benchmarking from "./Pages/Base/BenchMarking/Benchmarking";
import Budget from "./Pages/Base/Budget/Budget";
import Baseline from "./Pages/Base/Baseline/Baseline";
import ExternalEmails from "./Pages/Base/ControlPanel/ExternalEmails/ExternalEmails";
import AcceptGdpr from "./Components/Permissions/AcceptGdpr";
import AccessDenied from "./Components/Permissions/AccessDenied";
import UpgradePlan from "./Components/Permissions/UpgradePlan";
import { getToken, getUser } from "./Services/authService";
import { get as getCusServ } from "./Services/customerServices";
import PortfolioList from "./Pages/Base/Portfolio/portfolioList";
import StakeHolderList from "./Pages/Base/Stakeholders/StakeHolderList";
import { useLoginPermissionProvider } from "./Providers/LoginPermissionProvider";
import { AdminLogin } from "./Components/Authetication/AdminLogin";


export const UserContext = createContext();

const App = () => {
	const [customer, setCustomer] = useState({});
	const [customerId, setCustomerId] = useState(null);
	const [branchIdFromLS, setBranchIdFromLS] = useState();
	const [userPrivileges, setUserPrivileges] = useState();
	const [branchDetails, setBranchDetails] = useState([]);
	const [branchId, setBranchId] = useState('');
	const [branchDetail, setBranchDetail] = useState([]);
	const [branch, setBranch] = useState({});
	const [relationshipOwner, setRelationshipOwner] = useState([]);
	const [newLogo, setNewLogo] = useState(false);
	const { clientName } = useParams();
	const [customerShort, setCustomerShort] = useState('');
	const { globalLoginPermission} = useLoginPermissionProvider();
	const isRestricted = globalLoginPermission.isRestricted;
	const isAdmin = globalLoginPermission.isAdmin;
	const isBranchAdmin = globalLoginPermission.isBranchAdmin;

	

	useEffect(() => {
		const enduserStr = localStorage.getItem("enduser");
		if (enduserStr) {
			const enduser = JSON.parse(enduserStr);
			setCustomer(enduser);
			var cust = enduser.customer;
			setCustomerId(cust);
			const branch = enduser.branch;
			setBranchIdFromLS(branch);

		} else {
			// <Navigate to="/login" replace />
		}
		const tmpPrivilege = localStorage.getItem("user_privileges");
		if(tmpPrivilege){
			setUserPrivileges(JSON.parse(tmpPrivilege))
		}
	}, []);

	useEffect(() => {
		getBranchList()
		getBranchUsers()
	}, [customerId])

	useEffect(() => {
		const token = localStorage.getItem("token");
		if (token) {
			handleUserAuth();
		}

	}, []);


	useEffect(() => {
		if (customerId != null) {
			getCustomerDetails();
		}
	}, [customerId]);

	const getCustomerDetails = async () => {
		if (customerId != null) {
		var customerData = await getCusServ(customerId)
		if(customerData){
			setCustomerShort(customerData.data.customer_short)
		}
		}
	}

	const getBranchList = async () => {
		if (customerId !== null) {
			try {
				const customerDataResponse = await list(customerId, 'branch_name', -1);
				if(customerDataResponse){
					setBranchDetails(customerDataResponse?.data?.branch);
					setBranchId(customerDataResponse?.data?.branch[0]?._id);
				}
			} catch (error) {
				console.error("Error fetching branch fields:", error);
			}
		}
	};

	const getBranchUsers = async () => {
		if (customerId !== null && branchIdFromLS !== null && branchIdFromLS !== undefined) {
			try {
				const customerDataResponse = await getBranchUser(customerId, branchIdFromLS.branch_id);
				if(customerDataResponse){
					setBranch(customerDataResponse.data[0]?.branch);
					setBranchDetail(customerDataResponse.data);
					setBranchDetails(customerDataResponse?.data?.branch);
					var relation = customerDataResponse.data.map(o => ({
						_id: o._id,
						label: o.firstname + " " + o.surname,
						status: o.status
					})
					)
					setRelationshipOwner(relation)
				}
			} catch (error) {
				console.error("Error fetching branch fields:", error);
			}
		}
	};

	const newLogoData = (data) => {
		setNewLogo(data)
	}
	const handleUserAuth = async () => {
		try {
			const data = await getUser();
			const userData = data.data;
			localStorage.setItem('enduser', JSON.stringify(userData));
			localStorage.setItem('user_privileges', JSON.stringify(userData.user_privileges));
		} catch (error) {
			console.error('Error fetching user data:', error);
			// Handle error (e.g., show notification, redirect, etc.)
		}
	};
	const validPaths = [
		'/login',
		'/forgotPassword',
		'/securityPolicies',
		'/reset_password/:id',
		'/mfa',
		'/acceptGdpr',
		'/accessDenied',
		'/upgradePlan',
		'/',
		'/dashboard/:customerShort',
		'/portfolio',
		'/portfolio/:opportunityId/:customerShort/:version',
		'/stakeholders',
		'/stakeholder/:clientId/:customerShort/:version',
		'/programmes',
		'/programme/:frameworkId/:customerShort',
		'/addressbook',
		'/businessPlan/:customerShort',
		'/targetPlan/:customerShort',
		'/benchmarking/:customerShort',

		// Admin routes
		'/controlPanel/stakeholderassessmentfields',
		'/controlPanel/rdsfields',
		'/controlPanel/fields',
		'/controlPanel/checklists',
		'/controlPanel/prompts',
		'/controlPanel/fieldconfig',
		'/controlPanel/datacollectionconfig',
		'/controlPanel/tableconfig',
		'/controlPanel/tooltip',
		'/controlPanel/datasubmitted',
		'/controlPanel/completiontracker',
		'/controlPanel/setup',
		'/controlPanel/users',
		'/controlPanel/permissions',
		'/controlPanel/stages',
		'/controlPanel/usagelog',
		'/controlPanel/factors',
		'/controlPanel/userclassification',
		'/controlPanel/jobtitles',
		'/controlPanel/gatewaypermissions',
		'/controlPanel/outbox',
		'/controlPanel/activityplantemplate',
		'/controlPanel/externalemails',
		'/myAccount',
		'/changepassword'
	];

	const branchAdminRoutes = [
		'/controlPanel/users',
		'/controlPanel/permissions',
		'/controlPanel/usagelog',
		'/controlPanel/userclassification'
	]


	const RestrictedRoute = ({ element }) => {
		const resolvedPath = useResolvedPath();
		const enduserStr = localStorage.getItem("enduser");
		if (enduserStr) {
			const enduser = JSON.parse(enduserStr);
			if(enduser){
				const isRestricted = enduser?.isRestricted;
				const currentPath = resolvedPath.pathname;
				// Check if the current path is valid
				const isValidPath = isPathValid(currentPath);
				if (isValidPath) {
					if (isRestricted) {
						return <Navigate to="/accessDenied" replace />;
					}
					return element;
				} else {
					if (isRestricted) {
						return <Navigate to="/portfolio" replace />;
					} else {
						if (customerShort) {
							return <Navigate to={`/dashboard/${customerShort}`} replace />;
						}
					}
				}
			}
		}
	};

	// Function to check if currentPath is valid
	function isPathValid(currentPath) {
		return validPaths.some(path => {
			const regexPath = path
				.replace(/:[^\s/]+/g, '([^/]+)')
				.replace(/\//g, '\\/');

			const regex = new RegExp(`^${regexPath}$`, 'i'); // Add the 'i' flag for case-insensitivity
			return regex.test(currentPath.trim());
		});
	}

	const FallbackRedirect = () => {
		const resolvedPath = useResolvedPath();
		const currentPath = resolvedPath.pathname;
		const enduserStr = localStorage.getItem("enduser");
		if (enduserStr) {
			const enduser = JSON.parse(enduserStr);
			if(enduser){
				const isRestricted = enduser?.isRestricted;
				const isAdmin = enduser?.isAdmin;
				const isBranchAdmin = enduser?.isBranchAdmin;
				if (validPaths.includes(currentPath)) {
					if (isRestricted) {
						return <Navigate to="/accessDenied" replace />;
					}
					if (!isAdmin && !isBranchAdmin) {
						return <Navigate to="/accessDenied" replace />;
		
					}
					if (!isAdmin && isBranchAdmin) {
						if (branchAdminRoutes.includes(currentPath)) {
							return <Navigate to={`${currentPath}`} replace />;
						}
						return <Navigate to="/accessDenied" replace />;
					}
					return <Navigate to={`${currentPath}`} replace />;
				} else {
					if (isRestricted) {
						return <Navigate to="/portfolio" replace />;
					}
					else {
						if (customerShort) {
							return <Navigate to={`/dashboard/${customerShort}`} replace />;
						}
					}
		
				}
		
			}
		}else{
			window.location.href = "login"
		}
	};
	
	return (
		<PopupProvider>
			<GlobalProvider>
				<BrowserRouter>
					<Routes>
						<Route path="/login" element={<Login />} />
						<Route path="/forgotPassword" element={<ForgetPassword />} />
						<Route path="/securityPolicies" element={<SecurityPolicies />} />
						<Route path="/reset_password/:id" element={<ResetPassword />} />
						<Route path="/adminLogin" element={<AdminLogin />} />

						<Route element={<PrivateRoute />}>
							<Route path="/mfa" element={<Mfa />} />
							<Route path="acceptGdpr" element={<AcceptGdpr />} />
							<Route path="/accessDenied" element={<AccessDenied />} />
							<Route path="upgradePlan" element={<UpgradePlan />} />

							<Route path="/" element={
								<UserContext.Provider value={{ newLogo, newLogoData }}>
									<Layout  />
								</UserContext.Provider>
							}>
								<Route path="/dashboard/:customerShort" element={<RestrictedRoute element={<Dashboard />} isRestricted={isRestricted} />} />
								<Route path="portfolio" element={<PortfolioList />} />
								<Route path="/portfolio/:opportunityId/:customerShort/:version" element={<PortfolioTabs branch={branch} customerId={customerId} />} />
								<Route path="stakeholders" element={<StakeHolderList />} />
								{/* <Route path="stakeholders" element={<RestrictedRoute element={<StakeHolderList />} isRestricted={isRestricted} />} /> */}
								{/* <Route path="stakeholder/:clientId/:customerShort/:version" element={<RestrictedRoute element={<ClientEdit clientName={decodeURIComponent(clientName)} />} isRestricted={isRestricted} />} /> */}
								<Route path="stakeholder/:clientId/:customerShort/:version" element={<ClientEdit clientName={decodeURIComponent(clientName)} />} />
								<Route path="programmes" element={<RestrictedRoute element={<Programmes />} isRestricted={isRestricted} />} />
								<Route path="/programme/:frameworkId/:customerShort" element={<ProgrammeTabs />} />
								<Route path="addressbook" element={<RestrictedRoute element={<AddressBook />} isRestricted={isRestricted} />} />
								<Route path="businessPlan/:customerShort" element={<RestrictedRoute element={<Budget />} isRestricted={isRestricted} />} />
								<Route path="targetPlan/:customerShort" element={<RestrictedRoute element={<Baseline />} isRestricted={isRestricted} />} />
								<Route path="benchmarking/:customerShort" element={<RestrictedRoute element={<Benchmarking />} isRestricted={isRestricted} />} />
								{(isAdmin || isBranchAdmin) && (
									<Route path="controlPanel">
										{isAdmin && (
											<>

												<Route path="stakeholderassessmentfields" element={<Rds_fields />} />
												<Route path="rdsfields" element={<Rds_fields />} />
												<Route path="fields" element={<Fields />} />
												<Route path="checklists" element={<CheckLists />} />
												<Route path="prompts" element={<Prompts />} />
												<Route path="fieldConfig" element={<FieldConfig />} />
												<Route path="datacollectionconfig" element={<DataCollectionConfig />} />
												<Route path="tableconfig" element={<TableConfig />} />
												<Route path="tooltip" element={<ToolTip />} />
												<Route path="datasubmitted" element={<DataSubmitted />} />
												<Route path="completiontracker" element={<CompletionTracker />} />
												<Route path="setup" element={<Setup newLogo={newLogoData} />} />
												<Route path="users" element={<Users />} />
												<Route path="permissions" element={<Permissions />} />
												<Route path="stages" element={<Stages />} />
												<Route path="usagelog" element={<UsageLog />} />
												<Route path="factors" element={<Factors />} />
												<Route path="userclassification" element={<UserClassification />} />
												<Route path="jobtitles" element={<JobTitles />} />
												<Route path="gatewaypermissions" element={<GatewayPermissions />} />
												<Route path="outbox" element={<Outbox />} />
												<Route path="activityplantemplate" element={<ActivityPlanTemplate />} />
												<Route path="externalemails" element={<ExternalEmails />} />
											</>
										)}

										{isBranchAdmin && !isAdmin && (
											<>
												<Route path="users" element={<Users />} />
												<Route path="permissions" element={<Permissions />} />
												<Route path="usagelog" element={<UsageLog />} />
												<Route path="userclassification" element={<UserClassification />} />
											</>
										)}
									</Route>
								)}


								<Route path="myAccount" element={<MyAccount />} />
								<Route path="changepassword" element={<ChangePassword />} />
							</Route>
						</Route>

						{/* Fallback route for unmatched paths */}
						<Route path="*" element={<FallbackRedirect />} />
					</Routes>
				</BrowserRouter>
			</GlobalProvider>
		</PopupProvider>
	);
};

export default App;